export type TimeRangePreset = '15m' | '1h' | '6h' | '24h';

export interface TimeRange {
  from: Date;
  to: Date;
}

export const computeTimeRange = (preset: TimeRangePreset, now: Date = new Date()): TimeRange => {
  const to = new Date(now.getTime());
  const ms =
    preset === '15m'
      ? 15 * 60 * 1000
      : preset === '1h'
        ? 60 * 60 * 1000
        : preset === '6h'
          ? 6 * 60 * 60 * 1000
          : 24 * 60 * 60 * 1000;
  const from = new Date(to.getTime() - ms);
  return { from, to };
};

